








































































































































































import Vue from "vue";
import { mapState, mapActions } from "vuex";
// import PublishmentForm from "@/components/Form/PublishmentForm.vue";
// import PublishmentPreview from "@/components/Form/PublishmentPreview.vue";
import AdvertisementPreview from "@/components/Form/AdvertisementPreview.vue";
import { PublishmentOrder } from "@/interfaces/publishmentorder";
import { PublishmentCourse } from "@/interfaces/publishmentcourse";
import { PublishmentLocality } from "@/interfaces/publishmentlocality";
import { Advertisement } from "@/interfaces/advertisement";
import _ from "lodash";
import { PublishmentRegion } from "@/interfaces/publishmentregion";
import DatePicker from "@/components/DatePicker.vue";
import { HeaderProcess } from "@/plugins/HeaderProcess";

export default Vue.extend({
  //components: { PublishmentForm, PublishmentPreview, AdvertisementPreview },
  components: { AdvertisementPreview, DatePicker },
  methods: {
    ...mapActions(["loadRegions", "loadLocalities", "loadCourses"]),
    async confirm(): Promise<void> {
      this.errors = {};
      this.isLoading = true;
      const postData: Record<string, unknown> = {};
      for (const [k, v] of Object.entries(this.publishmentOrder)) {
        if (_.isPlainObject(v) && (v as { "@id"?: string })["@id"]) {
          postData[k] = (v as { "@id"?: string })["@id"];
        } else {
          postData[k] = v;
        }
      }
      const decorated = await this.decoratePostData(postData);

      try {
        await this.$store.dispatch("post", [
          "/api/adv/publishment_orders/validate",
          decorated
        ]);
        this.phase = "confirm";
      } catch (violations) {
        for (const v of violations as {
          propertyPath: string;
          message: string;
        }[]) {
          this.$set(this.errors, v.propertyPath, v.message);
        }
      }
      this.isLoading = false;
    },

    async exec(): Promise<void> {
      this.errors = {};
      this.isLoading = true;
      const postData: Record<string, unknown> = {};
      for (const [k, v] of Object.entries(this.publishmentOrder)) {
        if (_.isPlainObject(v) && (v as { "@id"?: string })["@id"]) {
          postData[k] = (v as { "@id"?: string })["@id"];
        } else {
          postData[k] = v;
        }
      }
      const decorated = await this.decoratePostData(postData);

      try {
        await this.$store.dispatch("post", [
          "/api/adv/publishment_orders",
          decorated
        ]);
        this.phase = "confirm";
        this.$router.push({
          name: "AdvertiserAdvertisementsPublishmentComplete",
          params: { id: this.$route.params.id }
        });
      } catch (violations) {
        alert("登録時にエラーが発生しました");
      }
      this.isLoading = false;
    },

    decoratePostData(postData: Record<string, unknown>) {
      postData.paymentType = "none";

      return postData;
    }
  },

  computed: {
    ...mapState(["regions", "localities", "courses"]),
    headerProcess(): HeaderProcess {
      const hp = new HeaderProcess();
      hp.processes.push({ idx: 1, title: "広告新規作成" });
      hp.processes.push({ idx: 2, title: "広告新規作成確認画面" });
      hp.processes.push({ idx: 3, title: "広告掲載申し込み" });
      hp.processes.push({ idx: 4, title: "広告掲載申し込み確認画面" });
      hp.processes.push({ idx: 5, title: "広告掲載申し込み完了" });

      hp.activeIdx = this.phase == "input" ? 3 : 4;

      return hp;
    },
    isPage(): boolean {
      return true;
    },
    dateFormatter(): (arg0: Date) => string {
      return (date: Date) => {
        return this.$formatter.dateHyphened(date);
      };
    },
    hasErrors(): boolean {
      return !_.isEmpty(this.errors);
    },
    selectableCourses(): PublishmentCourse[] {
      const selectable = [] as PublishmentCourse[];
      for (const c of this.courses) {
        if (c.isActive) {
          selectable.push(c);
        }
      }
      return selectable;
    },
    selectableRegions(): PublishmentRegion[] {
      const selectableIdx = {} as Record<number, boolean>;
      for (const l of this.localities) {
        selectableIdx[l.region.id] = true;
      }
      const selectable = [] as PublishmentRegion[];
      for (const r of this.regions) {
        if (r.id in selectableIdx) {
          selectable.push(r);
        }
      }

      return selectable;
    },
    selectableLocalities(): PublishmentLocality[] {
      const selectable = [] as PublishmentLocality[];
      for (const l of this.localities) {
        if (l.region.id == this.publishmentOrder.region?.id) {
          selectable.push(l);
        }
      }
      return selectable;
    },
    minPublishesAt(): Date {
      const d = new Date();
      d.setHours(d.getHours() - 17);
      d.setDate(d.getDate() + 2);
      d.setHours(0);
      d.setMinutes(0);
      d.setSeconds(-1);
      return d;
    }
  },
  data() {
    return {
      errors: {},
      advertisementExpanded: false,
      isLoading: false,
      phase: "input",
      publishmentOrder: {} as Partial<PublishmentOrder>,
      advertisement: {},
      baseAdvertisement: null as Advertisement | null | undefined
    };
  },
  async mounted() {
    this.advertisement = await this.$store.dispatch("get", [
      "/api/adv/posts/" + this.$route.params.id
    ]);
    this.publishmentOrder.advertisement = this.advertisement;
    if (this.$route.query.nextto) {
      this.baseAdvertisement = await this.$store.dispatch("get", [
        "/api/adv/posts/" + this.$route.query.nextto
      ]);
    }
    await this.loadRegions();
    await this.loadLocalities();
    await this.loadCourses();
    if (this.$route.query.nextto) {
      this.$nextTick(() => {
        this.$set(
          this.publishmentOrder,
          "region",
          this.baseAdvertisement?.publishmentOrder?.region
        );
        const l = this.selectableLocalities.find(c => {
          return c.id == this.baseAdvertisement?.publishmentOrder?.locality.id;
        });
        this.$set(this.publishmentOrder, "locality", l);
        if (this.baseAdvertisement?.publishmentOrder?.unpublishesAt) {
          const ps = new Date(
            this.baseAdvertisement?.publishmentOrder?.unpublishesAt
          );
          ps.setDate(ps.getDate() + 1);
          this.$set(this.publishmentOrder, "publishesAt", ps);
        }
      });
    }
  }
});
